<template>
<div class="modal" role="dialog">
  <div class="modal-content">
    <slot name="modal-content" :show="show"></slot>
  </div>
  <div class="modal-footer" v-if="hasFooter">
    <slot name="modal-footer"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    onOpenStart: {
      type: Function,
      default () {
        return () => {}
      }
    },
    onOpenEnd: {
      type: Function,
      default () {
        return () => {}
      }
    },
    onCloseStart: {
      type: Function,
      default () {
        return () => {}
      }
    },
    onCloseEnd: {
      type: Function,
      default () {
        return () => {}
      }
    },
    preventScrolling: {
      type: Boolean,
      default: true
    },
    startingTop: {
      type: String,
      default: '4%'
    },
    endingTop: {
      type: String,
      default: '10%'
    },
    hasFooter: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show (v) {
      if (v) {
        this.modal && this.modal.open()
      } else {
        this.modal && this.modal.close()
      }
    }
  },
  methods: {
    open () {
      this.modal.open()
      this.$emit('update:show', true)
    },
    close () {
      this.modal.close()
      this.$emit('update:show', false)
    },
    onEsc (e) {
      if (!this.dismissible || e.key !== 'Escape') {
        return
      }
      this.close()
    },
    onClickOutside () {
      if (!this.dismissible) {
        return
      }
      this.close()
    }
  },
  mounted () {
    const { preventScrolling, startingTop, endingTop } = this
    this.modal = window.M.Modal.init(this.$el, {
      dismissible: false,
      preventScrolling,
      startingTop,
      endingTop,
      onOpenStart: () => {
        this._lastFocus = document.activeElement
        this.onOpenStart()
        const closeBtns = this.$el.querySelectorAll('.modal-footer .modal-close')
        for (const btn of closeBtns) {
          btn.addEventListener('click', this.close)
        }
        document.body.addEventListener('keyup', this.onEsc)
      },
      onOpenEnd: () => {
        const overlay = document.querySelector('.modal-overlay')
        overlay.addEventListener('click', this.onClickOutside)
        this.onOpenEnd()
      },
      onCloseStart: () => {
        const closeBtns = this.$el.querySelectorAll('.modal-footer .modal-close')
        for (const btn of closeBtns) {
          btn.removeEventListener('click', this.close)
        }
        const overlay = document.querySelector('.modal-overlay')
        overlay.removeEventListener('click', this.onClickOutside)
        document.body.removeEventListener('keyup', this.onEsc)
        this.onCloseStart()
        this.$emit('update:show', false)
      },
      onCloseEnd: () => {
        this.onCloseEnd()
        this._lastFocus && this._lastFocus.focus()
      }
    })
  },
  beforeDestroy () {
    this.modal && this.modal.destroy()
  }
}
</script>

<style lang="scss" scoped>

</style>
